export default "__VITE_ASSET__BUiOi0cN__"